import { Col, Row, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { FC } from "react";
import { SelectableListDataType } from "./selectable-list";
import { DATE_TIME_FORMAT } from "../../../constants";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const ContentHeight = "70px";
interface SelectableListItemProps {
  data: SelectableListDataType;
}

export const SelectableListItem: FC<SelectableListItemProps> = (props) => {
  return (
    <Row style={{ width: "100%", cursor: "pointer"}}>
      <Col span={7} style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            height: ContentHeight,
            width: ContentHeight,
            border: "1px solid black",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography.Text>{props?.data?.initials?.toUpperCase()}</Typography.Text>
        </div>
      </Col>

      <Col span={17}>
        <div
          style={{
            marginLeft: "10px",
            minHeight: "100%",
          }}
        >
      <Typography.Text
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            marginBottom: 0,
            paddingRight: "10px",
          }}
         ellipsis strong
        >
          {props.data?.title}
        </Typography.Text>
          <br />

          <Typography.Text>{dayjs(props.data?.timestamp).utc().format(DATE_TIME_FORMAT).toUpperCase()
          }</Typography.Text>
          <br />
          <Tag style={{ border: "1px solid black" }}>{props.data?.progress}</Tag>
        </div>
      </Col>
    </Row>
  );
};
